<template>
  <div id="app" :class="moduleName">
    <router-view />
    <SideBar v-if="whoUseSideBar" />
  </div>
</template>

<script>
import ABTest from '@esign/esign-abtest-sdk'
import { mapMutations } from 'vuex'
import SideBar from '@/views/mixOs/components/pc/sideBar/index.vue'
export default {
  components: { SideBar },
  computed: {
    moduleName() {
      return this.$route.path.includes('bankeys') ? 'bankeys' : ''
    },
    // 落地页使用新sideBar 要求慢慢替换
    whoUseSideBar() {
      // 目前是这几个
      const useSideBar = [
        'semcontract',
        'common',
        'semsaas',
        'semsign',
        'semsignature',
        'semlocal',
        'semapi',
        'semsal',
        'semsignsaas',
        'sempro',
        'signetPrint',
      ]

      return useSideBar.some((item) => this.$route.fullPath.includes(item))
    },
  },
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    this.initLeft() // 初始化来一次
    this.buriedPointFn() // 页面分流接口
    // 解决多屏幕下 客服框居中问题
    window.addEventListener('resize', () => {
      this.initLeft()
    })
  },
  watch: {
    $route: {
      handler(val, oldval) {
        const paths = ['/landing/semlocal', '/landing/semsaas', '/landing/common', '/landing/semsign', '/landing/semsal']
        if (paths.includes(val.path.toLowerCase())) {
          const head = document.querySelector('head')
          if (head) {
            const node = document.createElement('script')
            node.innerHTML = `
            (function (w, d, t, r, u) {
        var f, n, i;
        w[u] = w[u] || [], f = function () {
          var o = { ti: "97086520", enableAutoSpaTracking: true };
          o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")
        },
          n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
            var s = this.readyState;
            s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
          },
          i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
      })(window, document, "script", "//bat.bing.com/bat.js", "uetq");
            function uet_report_conversion() {
                window.uetq = window.uetq || [];
                window.uetq.push("event", "submit_lead_form", {});
            }
            uet_report_conversion()
            `
            head.appendChild(node)
          }
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('abTest', ['setUuidInfo', 'setAbTestPlan']),
    async buriedPointFn() {
      // abTest页面分流，https://s.esign.cn/microfe/saas/abtest/list
      const ABT = new ABTest()
      const resData = await ABT.init({
        code: 'apply_name_association', // 根据产品配置填入的实验code
        env: 'WEB',
      })
      const { uuid } = resData
      console.log(uuid, 'uuid')
      this.setUuidInfo(uuid) // 存入vuex
      try {
        const endRes = await ABT.run()
        const { success, status, enterExperimentDomain, result } = endRes
        /**
         * success,true为成功
         * status,0:试验状态，进行中，1:全量放开，2:下线
         * enterExperimentDomain, 只有进行中会返回这个字段，是否进入实验
         * 具体见https://s.esign.cn/microfe/saas/abtest/list 中的【用户接入文档】
         */
        console.log(result, 'resultresult')
        if ((success && (status === 0 || 1)) || enterExperimentDomain) {
          if (result && result.length !== 0 && result[0] === 'name_input') {
            this.setAbTestPlan('name_input') // 在vuex存入【（老）留资企业名称】方案
          } else {
            this.setAbTestPlan('name_association') // 在vuex存入【（新）留资企业名称】方案
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    initLeft() {
      // 左侧需要特殊处理 分屏就不会居中 https://www.cnblogs.com/fmixue/p/13966451.html
      // eslint-disable-next-line no-restricted-globals
      const left = (window.screenX || window.screenLeft || 0) + (screen.width - 1200) / 2
      this.$store.commit('user/setLeft', left)
    },
  },
}
</script>
<style lang="less" scoped>
@import './assets/css/common.css';

:global {
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    overflow: auto;
    // 不要在这上面加height: 100% 会使document.documentElement.scrollTop拿不到值
  }

  #app.bankeys {
    height: 100%;
  }
}
</style>
